// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"94f1eb9b","455":"e62f28da","977":"87776752"}[chunkId] + ".chunk.js";
};